import { Box, Typography } from "@mui/material";
import { useStyles } from "./styles";
import dayjs, { Dayjs } from "dayjs";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { useEffect, useState } from "react";
import { useContextState } from "../../../../../../../../hooks/theme";


export const ChipDaysTranscurredSla = ({ children, startDate, timeConfig, isNull, finishDate }: { finishDate: Dayjs | null, children: ReactJSXElement, startDate?: Dayjs, timeConfig?: number, isNull: boolean }) => {

    const styles = useStyles();
    const { colors } = useContextState()
    const [bgColor, setBgColor] = useState(colors.color39);

    useEffect(() => {
        const updateColor = () => {
            if (!timeConfig) {
                setBgColor(colors.color39);
                return;
            }
            const endDate = finishDate ?? dayjs();
            const elapsedTime = endDate.diff(startDate, "milliseconds");
            const range = timeConfig / 3; // Dividir el tiempo en 3 partes

            const firstRange = range;
            const secondRange = firstRange + range;
            const thirdRange = secondRange + range;

            if (elapsedTime < firstRange) setBgColor(colors.color8); // Primer tramo
            else if (elapsedTime < secondRange) setBgColor(colors.color34); // Segundo tramo
            else setBgColor(colors.color19); // Último tramo
        };

        updateColor(); // Llamar la primera vez
        const interval = setInterval(updateColor, 1000); // Actualizar cada segundo

        return () => clearInterval(interval); // Limpiar el intervalo al desmontar
    }, [timeConfig, startDate]);


    return (
        <Box sx={styles.daysContainer(bgColor)}>
            {isNull
                ?
                <Typography color="textSecondary" sx={{ fontWeight: 'bold' }}>00 días 00:00:00</Typography>
                :
                children
            }
        </Box>
    );
};
